import React, { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Star, ArrowRight, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RedefiningYourDentalExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [mousePosition, setMousePosition] = useState({
    x: 0,
    y: 0
  });
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setMousePosition({
        x: e.clientX / window.innerWidth * 20,
        y: e.clientY / window.innerHeight * 20
      });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);
  return <section data-section-id="31608" id="sleep-soundly-in-la" ref={ref} className="bg-background text-foreground relative min-h-screen w-full overflow-hidden flex flex-col lg:flex-row">
      {}
      <div className="absolute inset-0 pointer-events-none z-0 opacity-[0.08]" style={{
      transform: `translate(${mousePosition.x * -0.5}px, ${mousePosition.y * -0.5}px)`,
      backgroundImage: `radial-gradient(circle at bottom left, var(--primary), transparent 60%)`
    }} />

      {}
      <div className="relative z-10 w-full lg:w-1/2 flex flex-col justify-center px-6 py-20 lg:p-24 xl:p-32">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Badge variant="outline" className="mb-6 w-fit border-primary/30 text-primary bg-primary/5 px-4 py-1.5 rounded-full text-sm tracking-wider uppercase font-bold">
            CPAP-Free Solutions
          </Badge>

          <h1 className="font-sans text-5xl md:text-6xl lg:text-7xl leading-[1.1] tracking-tighter mb-8 font-bold text-secondary">
            Sleep Soundly, <br />
            Breathe Freely in <br />
            <span className="text-primary">
              Los Angeles
            </span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-xl mb-10 leading-relaxed">
            Discover comfortable, effective alternatives to CPAP. Our specialized oral appliance therapy helps you reclaim your energy and health without the mask in a premium, clinical setting.
          </p>

          <div className="relative flex flex-col sm:flex-row items-start sm:items-center gap-8">
            {}
            <div className="relative group">
              <div className="absolute -inset-1 bg-chart-2 rounded-full blur opacity-20 group-hover:opacity-40 transition duration-500"></div>
              <Link to="#">
                <Button size="lg" className="relative rounded-full h-14 px-8 text-base font-bold bg-chart-2 hover:bg-chart-2/90 text-white shadow-xl transition-all duration-300 uppercase tracking-wide">
                  Book Free Consultation
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>

            {}
            <div className="relative sm:absolute sm:left-[280px] sm:-top-8 animate-[float_6s_ease-in-out_infinite]">
              <div className="bg-card/90 backdrop-blur-md border border-border/50 p-3 rounded-2xl shadow-xl flex items-center gap-3 min-w-[180px]">
                <div className="bg-primary/10 p-2 rounded-full">
                  <CircleCheck className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="flex items-center gap-1 text-amber-500">
                    <Star className="w-3.5 h-3.5 fill-current" />
                    <Star className="w-3.5 h-3.5 fill-current" />
                    <Star className="w-3.5 h-3.5 fill-current" />
                    <Star className="w-3.5 h-3.5 fill-current" />
                    <Star className="w-3.5 h-3.5 fill-current" />
                  </div>
                  <p className="text-xs font-bold text-secondary mt-0.5">
                    Top-Rated Sleep Clinic
                  </p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="mt-16 grid grid-cols-2 gap-6 max-w-md">
            {["CPAP Alternatives", "FDA Cleared Devices", "Insurance Accepted", "Expert Clinical Care"].map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-3 text-sm font-medium text-muted-foreground">
                <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                {benefit}
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full lg:w-1/2 min-h-[50vh] lg:min-h-screen overflow-hidden">
        <div className="absolute inset-0 bg-secondary/5 z-10 mix-blend-multiply pointer-events-none" />
        
        {}
        <div className="absolute inset-0 bg-white/5 z-20 pointer-events-none mix-blend-overlay" />
        
        {}
        <div className="absolute inset-0 bg-gradient-to-t lg:bg-gradient-to-l from-background via-transparent to-transparent z-20 opacity-90  !bg-[url(https://dentistforsleepapnea.com/wp-content/uploads/2026/04/image-5-1.webp)]" />
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-10px) rotate(1deg); }
          }
          @keyframes gradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
        `
    }} />
    </section>;
}